import { qsa } from 'music';

/**
 * Initializes form keypress handlers
 * @param {HTMLFormElement} form - form element
 * @param {HTMLButtonElement} submitButton - submit button for the form
 */
export default function initFormHandlers(form, submitButton) {
  const requiredFields = Array.from(form.querySelectorAll('ua-form-item'))
    .filter(requiredField => requiredField.hasRequiredValidation);
  handleKeyboardEvents();
  validatesForm();

  /**
   * Add keydown listener for text and password input elements
   * to prevent form submission on pressing Enter.
   *
   * Validate form when user changes the input in a required field
   * or clicks/tabs out of a required field.
   */
  function handleKeyboardEvents() {
    const elementList = qsa('input, select, fieldset', form);

    elementList.forEach((elm) => {
      if (elm.getAttribute('type') === 'text' || elm.getAttribute('type') === 'password') {
        elm.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
          }
        });
      }
    });

    requiredFields.forEach(field => {
      field.input.addEventListener('blur', validatesForm);
      field.input.addEventListener('input', validatesForm);
      field.input.addEventListener('change', validatesForm);
    });
  }

  /**
   * Checks required fields validity and enables submit button.
   */
  function validatesForm() {
    const requiredFieldsFilled = requiredFields
      .map((field) => {
        let inputValue = '';
        if (field.input.tagName === 'SELECT') {
          inputValue = field.input.options[field.input.selectedIndex].text;
        } else {
          inputValue = field.input.value;
        }
        return inputValue !== '' ? field.isValid : false;

      }).includes(false);
    submitButton.disabled = requiredFieldsFilled;
  }
}
